import { __extends } from "tslib";
import * as React from 'react';
import { noop } from '../../../../common';
import { namespacedClassnames } from '../../../../common/namespace-classes';
var BaseTableHeadCell = /** @class */ (function (_super) {
    __extends(BaseTableHeadCell, _super);
    function BaseTableHeadCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseTableHeadCell.prototype.render = function () {
        var props = this.props;
        var hideSeperator = props.hideSeperator ? 'hide-seperator' : false;
        var disabled = props.disabled ? 'disabled' : false;
        var classNames = namespacedClassnames('table-head-cell', hideSeperator, disabled, props.className);
        var onCellClickHandler = props.disabled ? noop : props.onClick || noop;
        return (React.createElement("div", { className: classNames, onClick: onCellClickHandler }, props.children));
    };
    return BaseTableHeadCell;
}(React.Component));
export { BaseTableHeadCell };
//# sourceMappingURL=base-table-head-cell.js.map